module.exports = __webpack_public_path__ + "static/img/1-1.35d66cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/1-1.png
// module id = T0Px
// module chunks = 0